import { logger } from "@/utils/debug";
import { useMapStore } from "@/stores/map";
import { useUIStore } from "@/stores/ui";
import type { ActionHandler } from "@/types/stores/actions";

export const uiActions: Record<string, ActionHandler> = {
  expand: async (_getDataflowState, _getUIState) => {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
    } catch (error) {
      logger.error("Error toggling fullscreen:", error);
    }
    return {};
  },

  report: (_getDataflowState, _getUIState) => {
    return {};
  },

  geocode: (_getDataflowState, _getUIState) => {
    return {
      modal: {
        mode: "enhancement",
        isOpen: true,
        title: "Geocode Dataset",
        data: { serviceId: "geocoding" },
      },
    };
  },

  enhancement: (_getDataflowState, _getUIState, payload?: unknown) => {
    const typedPayload = payload as { serviceId?: string } | undefined;
    return {
      modal: {
        mode: "enhancement",
        isOpen: true,
        title: "Enhance Data",
        data: typedPayload,
      },
    };
  },

  save: (_getDataflowState, _getUIState) => {
    return {
      modal: {
        mode: "save",
        isOpen: true,
        title: "Save to My Data",
      },
    };
  },

  layers: (_getDataflowState, _getUIState) => {
    const uiStore = useUIStore.getState();
    const dataflowState = _getDataflowState();
    const dataflowId = dataflowState.activeDataflowId;
    if (!dataflowId) return {};

    const workspaceUI = uiStore.getWorkspaceUI(dataflowId);
    if (!workspaceUI || !workspaceUI.sidebar) {
      return {
        sidebar: { mode: "layers", isOpen: true },
      };
    }

    const shouldClose =
      workspaceUI.sidebar.isOpen && workspaceUI.sidebar.mode === "layers";

    return {
      sidebar: shouldClose
        ? { isOpen: false }
        : { mode: "layers", isOpen: true },
    };
  },

  toggle_text_layers: (_getDataflowState, _getUIState) => {
    const mapStore = useMapStore.getState();
    mapStore.toggleTextLayers();
    return {};
  },

  toggle_roads_layers: (_getDataflowState, _getUIState) => {
    const mapStore = useMapStore.getState();
    mapStore.toggleRoadsLayers();
    return {};
  },

  toggle_data_labels: (_getDataflowState, _getUIState) => {
    const mapStore = useMapStore.getState();
    mapStore.toggleDataLabels();
    return {};
  },
};

